export const ICON_CONSTANTS: IIconConstants = {
  MENU_ICON: "mdi-menu",
  ACCOUNT_OUTLINE: "mdi-account-outline",
  HEART_OUTLINE: "mdi-heart-outline",
  CART_OUTLINE: "mdi-cart-outline",
  EYE_OUTLINE: "mdi-eye-outline",
  EYE_OFF_OUTLINE: "mdi-eye-off-outline",
  DELETE_OUTLINE: "mdi-trash-can-outline ",
  GIFT: "mdi-gift",
  WEB: "mdi-web",
  STORE: "mdi-store",
  FILE_DOCUMENT: "mdi-file-document-outline",
  ICON_PLUS: "mdi-plus",
  ICON_MINUS: "mdi-minus",
  ICON_SUPPORT: "mdi-face-agent",
  ICON_FILTER: "mdi-filter-outline",
  ICON_EYE: "mdi-eye",
  ICON_SAVE: "mdi-content-save-outline",
  CHECK_CIRCLE: "mdi-check-circle",
  SQUARE_EDIT_OUTLINE: "mdi-square-edit-outline",
  PENCIL_OUTLINE: "mdi-pencil-outline",
  CHEVRON_DOWN_ICON: "mdi-chevron-down",
  CLOSE_ICON: "mdi-close",
  CIRCLE_SMALL: "mdi-circle-small",
  INSTAGRAM: "mdi-instagram",
  FACEBOOK: "mdi-facebook",
  PINTEREST: "mdi-pinterest",
  YOUTUBE: "mdi-youtube",
  LINKEDIN: "mdi-linkedin",
  TWITTER: "mdi-twitter",
  EDIT_OUTLINE: "mdi-pencil-outline",
  BELL_OUTLINE: "mdi-bell-outline",
};

interface IIconConstants {
  MENU_ICON: string;
  ACCOUNT_OUTLINE: string;
  HEART_OUTLINE: string;
  CART_OUTLINE: string;
  EYE_OUTLINE: string;
  EYE_OFF_OUTLINE: string;
  DELETE_OUTLINE: string;
  GIFT: string;
  WEB: string;
  STORE: string;
  FILE_DOCUMENT: string;
  EDIT_OUTLINE: string;
  ICON_PLUS: string;
  ICON_MINUS: string;
  ICON_SUPPORT: string;
  ICON_FILTER: string;
  ICON_EYE: string;
  ICON_SAVE: string;
  CHECK_CIRCLE: string;
  SQUARE_EDIT_OUTLINE: string;
  PENCIL_OUTLINE: string;
  CHEVRON_DOWN_ICON: string;
  CLOSE_ICON: string;
  CIRCLE_SMALL: string;
  INSTAGRAM: string;
  FACEBOOK: string;
  PINTEREST: string;
  YOUTUBE: string;
  LINKEDIN: string;
  TWITTER: string;
  BELL_OUTLINE: string;
}
